// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLensTilt_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19 4 22 0H16L19 4ZM5 20 2 24H8L5 20ZM24 12C24 18.6274 18.6274 24 12 24 11.4654 24 10.939 23.965 10.423 23.8973L8.53852 21.3847C9.61712 21.7827 10.7832 22 12 22 17.5228 22 22 17.5228 22 12 22 9.74857 21.256 7.67092 20.0004 5.99951L21.2415 4.34473C22.9643 6.42224 24 9.09017 24 12ZM3.99964 18.0005C2.74404 16.3291 2 14.2514 2 12 2 6.47715 6.47715 2 12 2 13.2168 2 14.3829 2.21734 15.4615 2.61531L13.577.102701C13.061.0349538 12.5346 0 12 0 5.37258 0 0 5.37258 0 12 0 14.9098 1.03569 17.5778 2.75855 19.6553L3.99964 18.0005Z" class="svg-bg"/>
  <path d="M11 6.08356C8.16229 6.55964 6 9.02761 6 12.0006L4.00001 12.0008C4.00001 7.92115 7.05369 4.5546 11 4.0625V6.08356Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLensTilt is a generated icon component.
 */
let IconMedLensTilt = IconMedLensTilt_1 = class IconMedLensTilt extends IconBaseElement {
    render() {
        return html `${IconMedLensTilt_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLensTilt.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLensTilt = IconMedLensTilt_1 = __decorate([
    customElement('zui-icon-med-lens-tilt')
], IconMedLensTilt);
export { IconMedLensTilt };
